import dayjs from "dayjs";

export const exportTranscriptToText = ({
  metaData = {},
  exportTranscript,
  isHostedApp,
}) => {
  const transcriptBody = document.querySelector(".transcript-body");
  const s = new XMLSerializer();
  const str = s.serializeToString(transcriptBody);

  let formattedText2 = str;
  // Replace first turn div found with empty string and subsequent turn divs with new line
  formattedText2 = formattedText2.replace(/<div class="turn-p[^<]*>/, "");
  formattedText2 = formattedText2.replace(/<div class="turn-p[^<]*>/gi, "\n");
  // Replace first chat/messaging turn div with empty string and subsequent chat/messaging turn divs with new line
  formattedText2 = formattedText2.replace(
    /<div class="transcript-turn[^<]*>/,
    ""
  );
  formattedText2 = formattedText2.replace(
    /<div class="transcript-turn[^<]*>/gi,
    "\n"
  );
  // Replace all closing </a> tags with new line
  formattedText2 = formattedText2.replace(/<\/a>/gi, "\n");
  // Replace all <div> tags with empty string
  formattedText2 = formattedText2.replace(/<div[^<]*>/gi, "");
  // Replace all closing </div> tags with empty string
  formattedText2 = formattedText2.replace(/<\/div>/gi, "");
  // Replace all remaining tags with empty string
  formattedText2 = formattedText2.replace(/<[^>]+>/gi, "");

  const encodedUri = encodeURIComponent(formattedText2);
  const agentName =
    metaData?.detail?.callDetails?.agent?.fullName || "No agent details";
  const callStartTime = (
    metaData?.detail?.parsedDate ||
    dayjs(new Date()).format("MMM DD, YYYY, hh:mm:ss A")
  ).replace(/:/g, "");

  const element = document.createElement("a");
  element.style.display = "none";
  element.setAttribute("href", "data:text/plain;charset=utf-8," + encodedUri);
  element.setAttribute("download", `${agentName}_${callStartTime}.txt`);
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);

  if (!isHostedApp) {
    exportTranscript(encodedUri);
  }
};
